(function () {
  /* ─── URL-only param reading (single source of truth) ─── */
  function getActiveSize(section) {
    var paramKey = section.dataset.paramKey || 'size';
    var params = new URLSearchParams(window.location.search);
    return (params.get(paramKey) || '').trim();
  }

  /* ─── Data Parsing ─── */
  function parseAvailableSizes(item) {
    var raw = item.getAttribute('data-available-sizes');
    if (!raw || raw === 'null' || raw === '""') return null;
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function extractFirstSegmentNumber(compoundSize) {
    var firstSegment = String(compoundSize).split('/')[0].trim();
    return firstSegment.replace(/^[A-Za-z\s\-]+/, '').trim();
  }

  function isMatch(availableSizes, requestedSize) {
    if (!availableSizes || availableSizes.length === 0) return false;
    return availableSizes.some(function (compoundSize) {
      return extractFirstSegmentNumber(compoundSize) === requestedSize;
    });
  }

  /* ─── UI Updates ─── */
  function updateSummary(section, matchedCount, sizeValue, isFiltered) {
    var summary = section.querySelector('[data-sale-filter-summary]');
    var template = section.dataset.resultText || 'Showing [count] products for size [size]';
    if (!summary) return;
    if (!isFiltered) {
      summary.hidden = true;
      summary.textContent = '';
      return;
    }
    summary.hidden = false;
    summary.textContent = template
      .replace(/\[count\]/g, String(matchedCount))
      .replace(/\[size\]/g, sizeValue);
  }

  function refreshSlider(section) {
    var slider = section.querySelector('.flickityt4s');
    if (!slider) return;
    var flkty = null;
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      flkty = window.Flickity.data(slider);
    }
    if (!flkty && window.jQuery_T4NT) {
      flkty = window.jQuery_T4NT(slider).data('flickity') || null;
    }
    if (flkty) {
      flkty.reloadCells();
      flkty.resize();
      if (flkty.slides && flkty.slides.length) flkty.select(0, false, true);
      return;
    }
    window.dispatchEvent(new Event('resize'));
  }

  /* ─── Core Filter ─── */
  function applyFilter(section) {
    var activeSize = getActiveSize(section);
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-sale-filter-item]'));
    var emptyState = section.querySelector('[data-sale-filter-empty]');
    var productsWrap = section.querySelector('.t4s-products');
    var matchedCount = 0;
    var isFiltered = activeSize.length > 0;

    items.forEach(function (item) {
      var matched = true;
      if (isFiltered) {
        var availableSizes = parseAvailableSizes(item);
        matched = isMatch(availableSizes, activeSize);
      }
      item.setAttribute('data-sale-filter-hidden', matched ? 'false' : 'true');
      if (matched) matchedCount++;
    });

    updateSummary(section, matchedCount, activeSize, isFiltered);

    if (emptyState) {
      emptyState.hidden = !isFiltered || matchedCount > 0;
    }
    if (productsWrap && section.dataset.hideWhenEmpty === 'true') {
      productsWrap.hidden = isFiltered && matchedCount === 0;
    }

    refreshSlider(section);
    syncPickerUI(section, activeSize);
  }

  /* ─── Picker: collapsed / expanded state ─── */
  function syncPickerUI(section, activeSize) {
    var picker = section.querySelector('[data-sale-filter-picker]');
    if (!picker) return;

    var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-sale-filter-size]'));
    var trigger = picker.querySelector('[data-sale-filter-trigger]');
    var clearBtn = picker.querySelector('[data-sale-filter-clear]');
    var isExpanded = picker.dataset.expanded === 'true';

    // Update aria-pressed on all buttons
    buttons.forEach(function (btn) {
      var btnSize = btn.getAttribute('data-sale-filter-size');
      btn.setAttribute('aria-pressed', btnSize === activeSize ? 'true' : 'false');
    });

    // Update trigger text
    if (trigger) {
      var label = picker.querySelector('.t4s-sale-filter-picker__label');
      var labelText = label ? label.textContent.replace(':', '').trim() : 'Size';
      if (activeSize) {
        trigger.textContent = labelText + ': ' + activeSize + ' ▾';
        trigger.classList.add('t4s-sale-filter-trigger--active');
      } else {
        trigger.textContent = labelText + ': All ▾';
        trigger.classList.remove('t4s-sale-filter-trigger--active');
      }
    }

    // Show/hide clear button
    if (clearBtn) {
      clearBtn.hidden = !activeSize;
    }

    // Collapse after selection
    if (!isExpanded) {
      buttons.forEach(function (btn) { btn.hidden = true; });
      if (clearBtn) clearBtn.hidden = true;
    } else {
      buttons.forEach(function (btn) { btn.hidden = false; });
      if (clearBtn) clearBtn.hidden = !activeSize;
    }
  }

  function togglePicker(picker) {
    var isExpanded = picker.dataset.expanded === 'true';
    picker.dataset.expanded = isExpanded ? 'false' : 'true';

    var buttons = Array.prototype.slice.call(picker.querySelectorAll('[data-sale-filter-size]'));
    var clearBtn = picker.querySelector('[data-sale-filter-clear]');
    var activeSize = '';
    var activeBtn = picker.querySelector('[data-sale-filter-size][aria-pressed="true"]');
    if (activeBtn) activeSize = activeBtn.getAttribute('data-sale-filter-size');

    if (isExpanded) {
      // Collapsing
      buttons.forEach(function (btn) { btn.hidden = true; });
      if (clearBtn) clearBtn.hidden = true;
    } else {
      // Expanding
      buttons.forEach(function (btn) { btn.hidden = false; });
      if (clearBtn) clearBtn.hidden = !activeSize;
    }
  }

  function setUrlParam(section, value) {
    var paramKey = section.dataset.paramKey || 'size';
    var params = new URLSearchParams(window.location.search);
    if (value) {
      params.set(paramKey, value);
    } else {
      params.delete(paramKey);
    }
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newUrl);
  }

  function initPicker(section) {
    var picker = section.querySelector('[data-sale-filter-picker]');
    if (!picker || picker.dataset.pickerBound === 'true') return;
    picker.dataset.pickerBound = 'true';

    // Sort size buttons numerically (small → large)
    var sizeButtons = Array.prototype.slice.call(picker.querySelectorAll('[data-sale-filter-size]'));
    sizeButtons.sort(function (a, b) {
      return parseFloat(a.getAttribute('data-sale-filter-size')) - parseFloat(b.getAttribute('data-sale-filter-size'));
    });
    var clearBtn = picker.querySelector('[data-sale-filter-clear]');
    var label = picker.querySelector('.t4s-sale-filter-picker__label');
    var trigger = picker.querySelector('[data-sale-filter-trigger]');

    // Rebuild DOM order: label → trigger → sorted buttons → clear
    if (label) picker.appendChild(label);
    if (trigger) picker.appendChild(trigger);
    sizeButtons.forEach(function (btn) { picker.appendChild(btn); });
    if (clearBtn) picker.appendChild(clearBtn);

    // Start collapsed
    picker.dataset.expanded = 'false';

    // Event delegation
    picker.addEventListener('click', function (e) {
      // Trigger click → toggle expand/collapse
      var triggerBtn = e.target.closest('[data-sale-filter-trigger]');
      if (triggerBtn) {
        togglePicker(picker);
        return;
      }

      // Size button click → select, update URL, collapse
      var sizeBtn = e.target.closest('[data-sale-filter-size]');
      if (sizeBtn) {
        var clickedSize = sizeBtn.getAttribute('data-sale-filter-size');
        var currentSize = getActiveSize(section);

        if (clickedSize === currentSize) {
          // Deselect
          setUrlParam(section, '');
        } else {
          setUrlParam(section, clickedSize);
        }

        // Collapse after selection
        picker.dataset.expanded = 'false';
        applyFilter(section);
        return;
      }

      // Clear button
      var clrBtn = e.target.closest('[data-sale-filter-clear]');
      if (clrBtn) {
        setUrlParam(section, '');
        picker.dataset.expanded = 'false';
        applyFilter(section);
      }
    });
  }

  /* ─── MutationObserver for Load More ─── */
  function observeLoadMore(section) {
    var productsContainer = section.querySelector('[data-contentlm-replace]');
    if (!productsContainer) {
      productsContainer = section.querySelector('.t4s-products');
    }
    if (!productsContainer || productsContainer.dataset.saleFilterObserved === 'true') return;
    productsContainer.dataset.saleFilterObserved = 'true';

    var observer = new MutationObserver(function (mutations) {
      var hasNewItems = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              if (node.hasAttribute && node.hasAttribute('data-sale-filter-item')) {
                hasNewItems = true;
              } else if (node.querySelectorAll) {
                if (node.querySelectorAll('[data-sale-filter-item]').length > 0) hasNewItems = true;
              }
            }
          }
        }
      });
      if (hasNewItems) {
        setTimeout(function () { applyFilter(section); }, 100);
      }
    });

    observer.observe(productsContainer, { childList: true, subtree: true });
  }

  /* ─── Init ─── */
  function initSection(section) {
    if (!section || section.dataset.saleFilterReady === 'true') return;
    section.dataset.saleFilterReady = 'true';
    initPicker(section);
    applyFilter(section);
    observeLoadMore(section);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = Array.prototype.slice.call(
      scope.querySelectorAll('[data-sale-filter-collection]')
    );
    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();